import React from "react";

export default function InternationalRateResultTable({ rates, form }) {
  if (!rates || rates.length === 0) return null;

  // Function to get courier logo based on name
  const getCourierLogo = (courierName) => {
    const name = courierName.toLowerCase();

    if (name.includes("fedex")) {
      return "/image/fedex.png";
    } else if (name.includes("ups")) {
      return "/image/ups.png";
    } else if (name.includes("shipmozo")) {
      return "/image/shipmozo.png";
    } else if (name.includes("aramex")) {
      return "/image/aramax.png";
    } else if (name.includes("dhl")) {
      return "/image/dhl.png"; // You may need to add this logo
    } else {
      // Default case - return null to show text instead
      return null;
    }
  };

  return (
    <div className="overflow-x-auto rounded-xl shadow-md border border-indigo-200 bg-white">
      <table className="min-w-full divide-y divide-indigo-200">
        <thead className="bg-blue-900">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Company Logo
            </th>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Company Name
            </th>
            {/* <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Chg. Weight
            </th> */}
            {/* <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Est. Delivery
            </th> */}

            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Shipping Charges (₹)
            </th>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              GST (%)
            </th>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              GST (₹)
            </th>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Total Charges (₹)
            </th>
            <th className="px-4 py-3 text-left text-xs font-bold text-white uppercase tracking-wider">
              Book Now
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-indigo-100 text-black">
          {rates.map((rate) => {
            const logoPath = getCourierLogo(rate.name);

            return (
              <tr key={rate.id || rate.name}>
                <td className="px-4 py-3">
                  {logoPath ? (
                    <img
                      src={logoPath}
                      alt={rate.name}
                      className="h-8 w-auto object-contain"
                      onError={(e) => {
                        // Hide image if it fails to load
                        e.target.style.display = "none";
                      }}
                    />
                  ) : (
                    <div className="h-8 w-8 bg-gray-200 rounded flex items-center justify-center">
                      <span className="text-xs text-gray-500">--</span>
                    </div>
                  )}
                </td>
                <td className="px-4 py-3 font-semibold text-blue-900">
                  {rate.name}
                </td>
                {/* <td className="px-4 py-3 text-black">
                  {rate.minimum_chargeable_weight}
                </td> */}
                {/* <td className="px-4 py-3">
                  {rate.estimated_delivery && rate.estimated_delivery !== ""
                    ? rate.estimated_delivery
                    : "--"}
                </td> */}

                <td className="px-4 py-3">₹ {rate.shipping_charges}</td>
                <td className="px-4 py-3">{rate.gst_percentage}%</td>
                <td className="px-4 py-3">₹ {rate.gst}</td>
                <td className="px-4 py-3 ">₹ {rate.total_charges}</td>
                <td className="px-4 py-3">
                  <a
                    href={`https://wa.me/918874262636?text=${encodeURIComponent(
                      `Hi, I am interested in shipping. Here are the details: ` +
                        JSON.stringify({
                          pickup_pincode: form?.pickup_pincode || "",
                          delivery_pincode: form?.delivery_pincode || "",
                          delivery_country_id: form?.delivery_country_id || "",
                          order_amount: form?.order_amount || "",
                          type_of_package: form?.type_of_package || "",
                          shipment_purpose: form?.shipment_purpose || "",
                          weight: form?.weight || "",
                          dimensions: form?.dimensions || [],
                        })
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-white bg-blue-900 rounded-md px-3 py-1.5 text-xs hover:bg-blue-900"
                  >
                    Whatsapp
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
